/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ISocialLinkContainerViewProps } from './social-link-container';

export default (props: ISocialLinkContainerViewProps) => {
    return (
        <div data-content-type='row' data-appearance='contained' data-element='main'>
            <div
                className='row_facebook_contact_us'
                data-enable-parallax={0}
                data-parallax-speed='0.5'
                data-background-images='{}'
                data-background-type='image'
                data-video-loop='true'
                data-video-play-only-visible='true'
                data-video-lazy-load='true'
                data-video-fallback-src
                data-element='inner'
                style={{
                    justifyContent: 'flex-start',
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundPosition: 'left top',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundAttachment: 'scroll',
                    borderStyle: 'none',
                    borderWidth: '1px',
                    borderRadius: '0px',
                    margin: '0px 0px 10px',
                    padding: '10px'
                }}
            >
                <div
                    className='pagebuilder-column-group'
                    data-content-type='column-group'
                    data-grid-size={12}
                    data-element='main'
                    style={{ display: 'flex' }}
                >
                    {props.config.socialMediaLinks &&
                        props.config.socialMediaLinks.map((link, index) => {
                            return (
                                <div
                                    key={index}
                                    className='pagebuilder-column'
                                    data-content-type='column'
                                    data-appearance='full-height'
                                    data-background-images='{}'
                                    data-element='main'
                                    style={{
                                        justifyContent: 'flex-start',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        backgroundPosition: 'left top',
                                        backgroundSize: 'cover',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundAttachment: 'scroll',
                                        borderStyle: 'none',
                                        borderWidth: '1px',
                                        borderRadius: '0px',
                                        width: '50%',
                                        margin: '0px',
                                        padding: '10px',
                                        alignSelf: 'stretch'
                                    }}
                                >
                                    <figure
                                        data-content-type='image'
                                        data-appearance='full-width'
                                        data-element='main'
                                        style={{ textAlign: 'center', margin: '0px', padding: '0px', borderStyle: 'none' }}
                                    >
                                        <a
                                            href={link.link?.destinationUrl}
                                            target='_blank'
                                            data-link-type='default'
                                            title=''
                                            data-element='link'
                                            rel='noreferrer'
                                        >
                                            <img
                                                className='pagebuilder-mobile-hidden'
                                                src={link.icon?.src}
                                                alt={link.icon?.altText}
                                                title=''
                                                data-element='desktop_image'
                                                style={{
                                                    borderStyle: 'none',
                                                    borderWidth: '1px',
                                                    borderRadius: '0px',
                                                    maxWidth: '100%',
                                                    height: 'auto'
                                                }}
                                            />
                                            <img
                                                className='pagebuilder-mobile-only'
                                                src={link.icon?.src}
                                                alt={link.icon?.altText}
                                                title=''
                                                data-element='mobile_image'
                                                style={{
                                                    borderStyle: 'none',
                                                    borderWidth: '1px',
                                                    borderRadius: '0px',
                                                    maxWidth: '100%',
                                                    height: 'auto'
                                                }}
                                            />
                                        </a>
                                    </figure>
                                    <div
                                        data-content-type='text'
                                        data-appearance='default'
                                        data-element='main'
                                        style={{
                                            borderStyle: 'none',
                                            borderWidth: '1px',
                                            borderRadius: '0px',
                                            margin: '0px',
                                            padding: '0px'
                                        }}
                                    >
                                        <p style={{ textAlign: 'center' }} />
                                        <p style={{ textAlign: 'center' }}>
                                            <strong>{link.title}</strong>
                                        </p>
                                        <p style={{ textAlign: 'center' }}>{link.subtitle}</p>
                                    </div>
                                </div>
                            );
                        })}
                </div>
            </div>
        </div>
    );
};
